import './index.css';
import {useTranslation} from "react-i18next";

export default function ErrorPage() {

    const { t } = useTranslation()

    return (
        <div id="error-page">
            <h1>Oops!</h1>
            <p>{t('error.message1')}</p>
            <p>{t('error.message2')} <b>support@proxyhands.com</b> {t('error.message3')}</p>
        </div>
    );
}